<template>
  <DxSelectBox
    :data-source="codeList"
    value=""
    :read-only="readOnly"
    :disabled="disabled"
    display-expr="cmnsCdNm"
    value-expr="cmnsCd"
    @value-changed="onChange"
    :class="inputClass"
    v-model="selected"
  />
</template>

<script>
import Vue from 'vue'
import DxSelectBox from 'devextreme-vue/select-box'

export default {
  components: {
    DxSelectBox
  },
  name: 'DxSelectCodeList',
  props: {
    id: {
      type: String,
      default: 'selectCode'
    },
    allYn: {
      type: String,
      default: 'Y'
    },
    callVue: {
      type: String,
      default: 'manage'
    },
    inputClass: '',
    value: '',
    cmnsCdGrpId: '',
    disabled: false,
    readOnly: false,
    useCode: {
      type: String,
      default: ''
    },
    ignoreList: {
      type: Array,
      default: () => []
    },
    refCode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      url: '/api/appmgmt/common/code/list',
      codeList: [],
      originList: []
    }
  },
  computed: {
    selected: {
      get () {
        return this.value
      },
      set () {}
    }
  },
  watch: {
    'ignoreList': 'setCodeList',
    'refCode': 'setCodeList',
    value (v) {
      // 값 초기화시 '전체' 코드가 없을 경우 codeList의 첫번째 값으로 변경
      if (v === '') this.checkCurrentValue()
    }
  },
  mounted: function () {
    let params = {
      cmnsCdGrpId: this.cmnsCdGrpId
    }
    if (this.callVue === 'login') {
      this.url = '/api/appmgmt/public/common/code/list'
    }
    Vue.httpClient
      .get(this.url, {params: params, data: {isLoadingHide: 'Y'}})
      .then((result) => {
        this.originList = result.data.result
        this.setCodeList()
      })
  },
  methods: {
    onChange (e) {
      this.$emit('input', e.value)
      this.$emit('select-code-complete', e.value)
    },
    setCodeList () {
      const ignoredList = this.getIgnoredList()
      const refList = this.getRefList(ignoredList)
      if (this.allYn !== 'N') {
        this.codeList = [{cmnsCd: '', cmnsCdNm: '전체'}, ...refList]
      } else {
        this.codeList = refList
      }
      this.checkCurrentValue()
    },
    getRefList (list) {
      if (this.refCode) {
        return list.filter(data => {
          if (data.cmnsCd.charAt(0) === this.refCode.charAt(0)) return true
          // if (data.rfer2GrpId === this.refCode) return true
        })
      } else {
        return list
      }
    },
    getIgnoredList () {
      if (this.ignoreList.length) {
        return this.originList.filter(originData => {
          const isIgnore = !!this.ignoreList.find(ignoreData => ignoreData === originData.cmnsCd)
          if (!isIgnore) return true
        })
      } else {
        return this.originList
      }
    },
    checkCurrentValue () {
      // 현재값이 codeList에 없을 경우 첫번째 값으로 변경
      const selectedCode = this.codeList.find(item => item.cmnsCd === this.value)
      if (!selectedCode && this.codeList[0]) {
        this.onChange({ value: this.codeList[0].cmnsCd })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DxSelectCodeList.vue